import { render } from "./PrivacyConsent.vue?vue&type=template&id=06201f10"
import script from "./PrivacyConsent.vue?vue&type=script&lang=ts"
export * from "./PrivacyConsent.vue?vue&type=script&lang=ts"
script.render = render

export default script